import { FunctionComponent, useState } from 'react'
import { QueryClientProvider, QueryClient } from 'react-query'
import ContextProvider from './context'

import { Container } from './styles'
import BemVindo from './components/BemVindo'
import Termos from './components/Termos'
import Cadastro from './components/Cadastro'
import SelecionaDoc from './components/SelecionaDoc'
import UploadDoc from './components/UploadDoc'
import PIN from './components/PIN'
import SMS from './components/SMS'
import DefinicaoSenha from './components/DefinicaoSenha'
import Encerramento from './components/Encerramento'

import { IStepsData } from 'shared/components/Steps/StepsComponent.types'

export const steps = {
  BemVindo: 0,
  Terms: 1,
  Cadastro: 2,
  SelecionaDoc: 3,
  UploadDoc: 4,
  Pin: 5,
  SMS: 6,
  DefinicaoSenha: 7,
  Encerramento: 8,
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
})

const OnBoarding: FunctionComponent = () => {
  const [selectedStep, setSelectedStep] = useState(steps.BemVindo)

  const components: IStepsData[] = [
    {
      component: <BemVindo setSelectedStep={setSelectedStep} />,
    },
    {
      component: <Termos setSelectedStep={setSelectedStep} />,
    },
    {
      component: <Cadastro setSelectedStep={setSelectedStep} />,
    },
    {
      component: <SelecionaDoc setSelectedStep={setSelectedStep} />,
    },
    {
      component: <UploadDoc setSelectedStep={setSelectedStep} />,
    },
    {
      component: <PIN setSelectedStep={setSelectedStep} />,
    },
    {
      component: <SMS setSelectedStep={setSelectedStep} />,
    },
    {
      component: <DefinicaoSenha setSelectedStep={setSelectedStep} />,
    },
    {
      component: <Encerramento />,
    },
  ]

  return (
    <QueryClientProvider client={queryClient}>
      <ContextProvider>
        <Container key="signUpKey">
          {components[selectedStep]?.component}
        </Container>
      </ContextProvider>
    </QueryClientProvider>
  )
}

export default OnBoarding
